import { render } from "./DialogActionPayment.vue?vue&type=template&id=4c68fa68"
import script from "./DialogActionPayment.vue?vue&type=script&lang=js"
export * from "./DialogActionPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__